import { RouteConf, ComponentConf, Resource, conf } from 'src/config'
import { isArray } from 'lodash'


export const getLabel: (rtConf: RouteConf) => string = (rtConf) => {
    const compConf: ComponentConf | ComponentConf[] = rtConf.comp;
    let label = '';
    if (!isArray(compConf)) {
        if (compConf.label != null) {
            return compConf.label;
        }
        if (compConf.type == 'list' || compConf.type == 'entity') {
            const resource: Resource = conf.getResource(compConf.resourceName);
            return resource.label || resource.name;
        }
    }
    return label;
}
